import { ApolloProvider, useApolloClient } from "@apollo/client"
import { Spinner } from "@chakra-ui/react"
import { useWebBlocksClient } from "../blocks/client"
import { MediaManager as BlocksMediaManager } from "@pathwright/legacy-media-manager"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import PropTypes from "prop-types"
import { Suspense } from "react"
import { usePathwrightContext } from "../pathwright/PathwrightContext"
import useAuthAwareQuery from "../utils/useAuthAwareQuery"
import MEDIA_CONTEXT_QUERY from "./graphql/media-context-query"

const mediaManagerDefaultPropRenderLoading = () => <Spinner />

const MediaManager = (props) => {
  props = {
    renderLoading: mediaManagerDefaultPropRenderLoading,
    ...props
  }

  const { data, loading, error } = useAuthAwareQuery(MEDIA_CONTEXT_QUERY)
  const pwContext = usePathwrightContext()

  // Either acquire a new blocks Apollo client or use the one in context
  // when testing provided by the ApolloMockingProvider.
  const blocksClient = useWebBlocksClient()
  const contextClient = useApolloClient()
  const client = contextClient?.defaultOptions?.mocking
    ? contextClient
    : blocksClient

  if (!pwContext.me) return null
  if (loading || !data) return props.renderLoading()
  if (error) return new Error(error)

  const { accountID, user, mediaStoragePath } = data.mediaContext

  return (
    <ApolloProvider client={client}>
      <Suspense fallback={LoadingCircle}>
        <BlocksMediaManager
          userID={user.id}
          accountID={accountID}
          mediaStoragePath={mediaStoragePath}
          {...props}
        />
      </Suspense>
    </ApolloProvider>
  )
}

MediaManager.propTypes = {
  contextKey: PropTypes.string,
  onChooseMedia: PropTypes.func,
  onOpenChange: PropTypes.func,
  preventChoosingMedia: PropTypes.bool,
  mediaType: PropTypes.string,
  pickOptions: PropTypes.object,
  renderButton: PropTypes.func,
  renderLoading: PropTypes.func,
  allowDownloadableVideos: PropTypes.bool
}

export default MediaManager
